/* const getContextRoutePath = contextPath => {
  return contextPath ? '/:context' : '';
}; */

export const useAppRoutes = () => {
  /* let { contextPath } = useAppConfigurations();
  const contextRoutePath = getContextRoutePath(contextPath);
  contextPath = contextPath ?? ''; */

  const contextPath = '';
  const contextRoutePath = '';

  const publicRoutes = {
    root: {
      path: `${contextRoutePath}`,
      url: `${contextPath}`,
    },
    privacyPoicy: {
      path: `${contextRoutePath}/privacy-policy`,
      url: `${contextPath}/privacy-policy`,
      documentTitle: 'Privacy Policy',
    },
    cookiePoicy: {
      path: `${contextRoutePath}/cookie-policy`,
      url: `${contextPath}/cookie-policy`,
      documentTitle: 'Cookie Policy',
    },
    termsAndConditions: {
      path: `${contextRoutePath}/terms-and-conditions`,
      url: `${contextPath}/terms-and-conditions`,
      documentTitle: 'Terms & Conditions',
    },
    unsubscribe: {
      path: `${contextRoutePath}/unsubscribe/:token`,
      url: `${contextPath}/unsubscribe`,
      documentTitle: 'Unsubscribe',
    },
    unsubscribeFromMonthlyReminders: {
      path: `${contextRoutePath}/unsubscribeFromMonthlyReminders/:userId`,
      url: `${contextPath}/unsubscribeFromMonthlyReminders`,
      documentTitle: 'Unsubscribe From Monthly Reminders',
    },
    login: {
      path: `${contextRoutePath}/login`,
      url: `${contextPath}/login`,
      documentTitle: 'Login',
    },
    twoFactorAuthentication: {
      path: `${contextRoutePath}/2fa`,
      url: `${contextPath}/2fa`,
      documentTitle: 'Two-Factor Authentication',
    },
    logout: {
      path: `${contextRoutePath}/logout`,
      url: `${contextPath}/logout`,
      documentTitle: 'Logout',
    },
    // register: {
    //   path: `${contextRoutePath}/register`,
    //   url: `${contextPath}/register`,
    //   documentTitle: 'Register',
    // },
    successRegistration: {
      path: `${contextRoutePath}/success-registration`,
      url: `${contextPath}/success-registration`,
      documentTitle: 'Registration Successful',
    },
    forgotpassword: {
      path: `${contextRoutePath}/forgotpassword`,
      url: `${contextPath}/forgotpassword`,
      documentTitle: 'Forgot Password',
    },
    registerBorrowerSuccessful: {
      path: `${contextRoutePath}/sucessfulBorrowerRegister`,
      url: `${contextPath}/sucessfulBorrowerRegister`,
      documentTitle: 'Registration Sucessful'
    },
    updatepassword: {
      path: `${contextRoutePath}/updatepassword/:token`,
      documentTitle: 'Update Password',
    },
    successupdatepassword: {
      path: `${contextRoutePath}/successupdatepassword`,
      url: `${contextPath}/successupdatepassword`,
      documentTitle: 'Update Password Successful',
    },
    createpassword: {
      path: `${contextRoutePath}/createpassword/:token`,
      documentTitle: 'Create Password',
    },
    createpasswordMigratedUser: {
      path: `${contextRoutePath}/createpassword-migrateduser/:token`,
      documentTitle: 'Create Password',
    },
    successcreatepassword: {
      path: `${contextRoutePath}/successcreatepassword`,
      url: `${contextPath}/successcreatepassword`,
      documentTitle: 'Create Password Successful',
    },
    successforgotpasswordemail: {
      path: `${contextRoutePath}/successforgotpasswordemail`,
      url: `${contextPath}/successforgotpasswordemail`,
      documentTitle: 'Forgot Password Email Successful',
    },
    valuationPayments: {
      path: `${contextRoutePath}/valuation-payment/:token`,
      url: `${contextPath}/valuation-payment/:token`,
    },
    tamariskDocumentDocusignCallback: {
      path: `${contextRoutePath}/tamarisk-document-docusign-callback`,
      url: `${contextPath}/tamarisk-document-docusign-callback`,
    },
    internalValuationDocumentDocusignCallback: {
      path: `${contextRoutePath}/internal-valuation-document-docusign-callback`,
      url: `${contextPath}/nternal-valuation-document-docusign-callback`,
    },
    // Old Fast Track links (/loan-fastrack-payments/<base64 id>): shows a static "ask your lender for a new link" page.
    loanFastrackPayments: {
      path: `${contextRoutePath}/loan-fastrack-payments/:encodedParams`,
      url: `${contextPath}/loan-fastrack-payments/:encodedParams`,
    },
    // Secure link flow page (session from the platform landing page /platform-app/link#token).
    secureLinkLoanFastrackPayment: {
      path: `${contextRoutePath}/link/loan-fastrack-payment`,
      documentTitle: 'Loan Fast Track Payment',
    },
    extensionAgreementSigning: {
      path: `${contextRoutePath}/extension-agreement/:token`,
      url: `${contextPath}/extension-agreement/:token`,
    },
    loanFastrackDocumentDocusignCallback: {
      path: `${contextRoutePath}/loan-fast-track-document-docusign-callback`,
      url: `${contextPath}/loan-fast-track-document-docusign-callback`,
    },
    creditAuthorization: {
      path: `${contextRoutePath}/credit-authorization`,
      documentTitle: 'Credit Authorization Form',
    },
    creditAuthorizationDocusignCallback: {
      path: `${contextRoutePath}/credit-authorization-docusign-callback`,
      documentTitle: 'Credit Authorization Form Callback',
    },
    wireAuthorization: {
      path: `${contextRoutePath}/wire-authorization/:uuid`,
      documentTitle: 'Wire Authorization Form',
    },
    mobileTruliooVerification: {
      path: `${contextRoutePath}/mobile-trulioo-verification`,
      documentTitle: 'Trulioo Verfication',
    },
    wireAuthorizationDocusignCallback: {
      path: `${contextRoutePath}/wire-authorization-docusign-callback`,
      documentTitle: 'Wire Authorization Form Callback',
    },
    mersOnboardingDocusignCallback: {
      path: `${contextRoutePath}/mers-onboarding-docusign-callback`,
      documentTitle: 'Mers Onboarding Form Callback',
    },
    // Old share links (/scope-of-work-v2/<base64 scope of work id, lender id and username>): shows a static "ask your lender for a new link" page.
    scopeOfWorkV2: {
      path: `${contextRoutePath}/scope-of-work-v2/:encodedParams`,
      documentTitle: 'Scope of Work',
    },
    // Secure link flow page (session from the platform landing page /platform-app/link#token).
    secureLinkScopeOfWork: {
      path: `${contextRoutePath}/link/scope-of-work`,
      documentTitle: 'Scope of Work',
    },
    // Old create links (/create-scope-of-work/<base64 lender id and username>): shows a static "ask your lender for a new link" page.
    createScopeOfWork: {
      path: `${contextRoutePath}/create-scope-of-work/:encodedParams`,
      documentTitle: 'Create Scope of Work',
    },
    // Secure link flow page (session from the platform landing page /platform-app/link#token).
    secureLinkCreateScopeOfWork: {
      path: `${contextRoutePath}/link/create-scope-of-work`,
      documentTitle: 'Create Scope of Work',
    },
    // The short create link (no params) of portals with a single lender: stays public, nportal finds the lender by host.
    createScopeOfWorkV2: {
      path: `${contextRoutePath}/create-scope-of-work`,
      documentTitle: 'Create Scope of Work',
    },
    drawRequest: {
      path: `${contextRoutePath}/draw-request/:encodedParams`,
      documentTitle: 'Draw Request',
    },
    denialOfCredit: {
      path: `${contextRoutePath}/denial-of-credit/:encodedParams`,
      documentTitle: 'Denial Of Credit',
    },
    plaid: {
      path: `${contextRoutePath}/plaid/:encodedParams`,
      documentTitle: 'Plaid Registration',
    },
    // Old liquidity verification links (/liquidity-verification/<encrypted params>), still emailed by nportal
    // PlaidRequestHelper: shows a static "ask your lender for a new link" page.
    liquidityVerification: {
      path: `${contextRoutePath}/liquidity-verification/:token`,
      documentTitle: 'Liquidity Verification',
    },
    docusignCallback: {
      path: `${contextRoutePath}/docusign/docusign-callback`,
      documentTitle: 'Docusign Callback',
    },
    // Old revision links (/scope-of-work-revision/<base64 draw id and username>): shows a static "ask your lender for a new link" page.
    scopeOfWorkRevision: {
      path: `${contextRoutePath}/scope-of-work-revision/:encodedParams`,
      documentTitle: 'Scope of Work Revision',
    },
    // Secure link flow page (session from the platform landing page /platform-app/link#token).
    secureLinkScopeOfWorkRevision: {
      path: `${contextRoutePath}/link/scope-of-work-revision`,
      documentTitle: 'Scope of Work Revision',
    },
    manageEmailSubscriptions: {
      path: `${contextRoutePath}/manage-subscriptions/:encodedParams`,
      documentTitle: 'Manage Subscriptions',
    },
    borrowerDetailsVerification: {
      path: `${contextRoutePath}/borrower-details-verification/:uuid`,
      documentTitle: 'Borrower Details Verification Form',
    },
    borrowerDetailsVerificationDocusignCallback: {
      path: `${contextRoutePath}/borrower-details-verification-docusign-callback/:uuid`,
      documentTitle: 'Borrower Details Verification Form Callback',
    },
    unsubscribedFromDailyReminders: {
      path: `${contextRoutePath}/unsubscribed-from-daily-reminders/:uuid`,
      documentTitle: 'Unsubscribed From Daily Reminders',
    },
    surveyUnsubscribe: {
      path: `${contextRoutePath}/survey/:token/unsubscribe`,
      documentTitle: 'Survey Unsubscribe',
    },
    survey: {
      path: `${contextRoutePath}/survey/:token`,
      documentTitle: 'Satisfaction Survey',
    },
    loanApplication: {
      path: `${contextRoutePath}/loan-application`,
      url: `${contextRoutePath}/loan-application`,
      documentTitle: 'Loan Application',
      children: {
        fixFlip: {
          path: `${contextRoutePath}/loan-application/fix-flip`,
          url: `${contextRoutePath}/loan-application/fix-flip`,
          documentTitle: 'New Fix & Flip Loan',
        },
        // groundUp: {
        //   path: `${contextRoutePath}/loan-application/ground-up`,
        //   url: `${contextRoutePath}/loan-application/ground-up`,
        //   documentTitle: 'New Ground Up Loan ',
        // },
        singleProperty: {
          path: `${contextRoutePath}/loan-application/single-property`,
          url: `${contextRoutePath}/loan-application/single-property`,
          documentTitle: 'New Single Property Loan ',
        },
      },
    },
    applyForALoan: {
      path: `${contextRoutePath}/apply-for-a-loan/:assignee?`,
      url: `${contextRoutePath}/apply-for-a-loan`,
      documentTitle: 'Apply for a Loan',
      children: {
        fixFlip: {
          path: `${contextRoutePath}/apply-for-a-loan/fix-flip/:assignee?`,
          url: `${contextRoutePath}/apply-for-a-loan/fix-flip`,
          documentTitle: 'New Fix & Flip Loan',
        },
        groundUp: {
          path: `${contextRoutePath}/apply-for-a-loan/ground-up/:assignee?`,
          url: `${contextRoutePath}/apply-for-a-loan/ground-up`,
          documentTitle: 'New Ground Up Loan',
        },
        singleProperty: {
          path: `${contextRoutePath}/apply-for-a-loan/single-property/:assignee?`,
          url: `${contextRoutePath}/apply-for-a-loan/single-property`,
          documentTitle: 'New Single Property Loan',
        },
      },
    },
    achFormDocusignCallback: {
      path: `${contextRoutePath}/ach/docusign`,
      documentTitle: 'ACH Form',
    },
    // Old ACH links (/ach/<HMAC token>): shows a static "ask your lender for a new link" page.
    achForm: {
      path: `${contextRoutePath}/ach/:token`,
      documentTitle: 'ACH Form',
    },
    // Secure link flow page (session from the platform landing page /platform-app/link#token).
    secureLinkAchForm: {
      path: `${contextRoutePath}/link/ach`,
      documentTitle: 'ACH Form',
    },
    referralFeeAuthDocusign: {
      path: `${contextRoutePath}/referral-fee/docusign`,
      documentTitle: 'Referral Fee Auth',
    },
    // Old referral fee links (/referral-fee/<token holding the loan id>): shows a static "ask for a new link" page.
    referralFeeAuth: {
      path: `${contextRoutePath}/referral-fee/:token`,
      documentTitle: 'Referral Fee',
    },
    // Secure link flow page (session from the platform landing page /platform-app/link#token).
    secureLinkReferralFee: {
      path: `${contextRoutePath}/link/referral-fee`,
      documentTitle: 'Referral Fee',
    },
    softCreditPull: {
      path: `${contextRoutePath}/soft-credit-pull`,
      documentTitle: 'Soft Pull - Credit Authorization',
      url: `${contextPath}/soft-credit-pull`,
    },
    backgroundPull: {
      path: `${contextRoutePath}/background-pull`,
      documentTitle: 'Background Pull',
      url: `${contextPath}/background-pull`,
    },
    softCreditPullWithParams: {
      path: `${contextRoutePath}/soft-credit-pull/:encodedParams`,
      documentTitle: 'Soft Pull - Credit Authorization',
      url: `${contextPath}/soft-credit-pull/:encodedParams`,
    },
    backgroundPullWithParams: {
      path: `${contextRoutePath}/background-pull/:encodedParams`,
      documentTitle: 'Background Pull',
      url: `${contextPath}/background-pull/:encodedParams`,
    },
    idVerification: {
      path: `${contextRoutePath}/id-verification/:encodedParams`,
      url: `${contextPath}/id-verification/:encodedParams`,
      documentTitle: 'ID Verification',
    },
    credit_auth_unused: {
      path: `${contextRoutePath}/credit_auth_unused`,
      documentTitle: 'Credit Authorization',
      url: `${contextPath}/credit_auth_unused`,
    },
    caf_pdf: {
      path: `${contextRoutePath}/caf-pdf`,
      documentTitle: 'Credit Authorization Form Pdf',
      url: `${contextPath}/caf-pdf`,
    },
    // Old link format (HMAC token in the URL): shows "no longer valid".
    wireInstructions: {
      path: `${contextRoutePath}/wire-instructions/:encodedParams`,
      documentTitle: 'Wire Instructions',
    },
    // Secure link flow page (session from the platform landing page /platform-app/link#token).
    secureLinkWireInstructions: {
      path: `${contextRoutePath}/link/wire-instructions`,
      documentTitle: 'Wire Instructions',
    },
    verifyBankInformation: {
      path: `${contextRoutePath}/verify-bank-info/:token`,
      documentTitle: 'Verify Bank Information',
    },
    fundingDocs: {
      path: `${contextRoutePath}/funding-docs/:token`,
      documentTitle: 'Funding Docs',
    },
  };

  return {
    contextPath,
    publicRoutes,
  };
};
